import React, { memo } from 'react';
import { Button } from '@miroculus/nucleo';
import classnames from 'classnames/bind';
import styles from './HeadingWithButton.scss';
const cx = classnames.bind(styles);
const HeadingWithButton = memo(({ title, titleAnnex, buttonTextElement, onButtonClick, buttonLinkTo, titleAnnexAlignment = 'left', showSmallTitle = false, buttonTestId = 'header-with-filters-button', }) => {
    const withButton = (onButtonClick || buttonLinkTo) && buttonTextElement;
    return (React.createElement("div", { className: cx('headingWithButtonContainer', { withButton }) },
        showSmallTitle ? React.createElement("h2", null, title) : React.createElement("h1", null, title),
        titleAnnex && titleAnnexAlignment !== 'right' ? titleAnnex : null,
        withButton && (React.createElement("div", { className: cx('headingButton') },
            titleAnnex && titleAnnexAlignment === 'right' ? titleAnnex : null,
            React.createElement(Button, { size: "small", "data-testid": buttonTestId, onClick: onButtonClick, to: buttonLinkTo }, buttonTextElement)))));
});
export default HeadingWithButton;
